import styled from 'styled-components';

export const FullWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0 auto;
  padding-top: 30px;

  ${(props) => props.theme.breakpoints.down('lg')} {
    flex-direction: column;
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 95%;
  }
`;
